
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gwq0h_1d4h3_149",
  "expand-button": "awsui_expand-button_gwq0h_1d4h3_184",
  "icon": "awsui_icon_gwq0h_1d4h3_188",
  "expanded": "awsui_expanded_gwq0h_1d4h3_202",
  "icon-container": "awsui_icon-container_gwq0h_1d4h3_215",
  "icon-container-container": "awsui_icon-container-container_gwq0h_1d4h3_219",
  "wrapper": "awsui_wrapper_gwq0h_1d4h3_223",
  "wrapper-default": "awsui_wrapper-default_gwq0h_1d4h3_231",
  "wrapper-inline": "awsui_wrapper-inline_gwq0h_1d4h3_231",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_1d4h3_231",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_1d4h3_235",
  "wrapper-container": "awsui_wrapper-container_gwq0h_1d4h3_238",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_1d4h3_242",
  "header-deprecated": "awsui_header-deprecated_gwq0h_1d4h3_255",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_1d4h3_274",
  "wrapper-not-expanded-without-actions": "awsui_wrapper-not-expanded-without-actions_gwq0h_1d4h3_319",
  "header": "awsui_header_gwq0h_1d4h3_255",
  "header-wrapper": "awsui_header-wrapper_gwq0h_1d4h3_336",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_1d4h3_348",
  "header-button": "awsui_header-button_gwq0h_1d4h3_356",
  "header-container-button": "awsui_header-container-button_gwq0h_1d4h3_356",
  "header-container": "awsui_header-container_gwq0h_1d4h3_356",
  "header-navigation": "awsui_header-navigation_gwq0h_1d4h3_391",
  "icon-container-end": "awsui_icon-container-end_gwq0h_1d4h3_404",
  "header-text": "awsui_header-text_gwq0h_1d4h3_436",
  "content": "awsui_content_gwq0h_1d4h3_446",
  "content-expanded": "awsui_content-expanded_gwq0h_1d4h3_449",
  "content-compact": "awsui_content-compact_gwq0h_1d4h3_452",
  "content-inner": "awsui_content-inner_gwq0h_1d4h3_456",
  "content-inner-expanded": "awsui_content-inner-expanded_gwq0h_1d4h3_460",
  "content-inner-settled": "awsui_content-inner-settled_gwq0h_1d4h3_464",
  "content-inner-body-default": "awsui_content-inner-body-default_gwq0h_1d4h3_468",
  "content-inner-body-inline": "awsui_content-inner-body-inline_gwq0h_1d4h3_468",
  "content-inner-body-footer": "awsui_content-inner-body-footer_gwq0h_1d4h3_471",
  "content-inner-body-container": "awsui_content-inner-body-container_gwq0h_1d4h3_474",
  "disable-header-paddings": "awsui_disable-header-paddings_gwq0h_1d4h3_479",
  "disable-content-paddings": "awsui_disable-content-paddings_gwq0h_1d4h3_484",
  "focusable": "awsui_focusable_gwq0h_1d4h3_489",
  "click-target": "awsui_click-target_gwq0h_1d4h3_504",
  "header-icon-end": "awsui_header-icon-end_gwq0h_1d4h3_511",
  "header-button-icon-end": "awsui_header-button-icon-end_gwq0h_1d4h3_528",
  "header-content": "awsui_header-content_gwq0h_1d4h3_582",
  "header-navigation-content": "awsui_header-navigation-content_gwq0h_1d4h3_588"
};
  